import { MemoryRouter, Routes, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Invoice from "vino/components/Invoice";

const CheckoutPage = () => {
	return (
		<MemoryRouter>
			<Routes>
				<Route path="/" element={<Checkout />} />
				<Route path="/invoice/:orderId" element={<Invoice />} />
			</Routes>
		</MemoryRouter>
	);
};

export default CheckoutPage;
